import PropTypes from 'prop-types'
import React, {useEffect, useState} from 'react'
import actions from 'redux-auto'
import {connect, useSelector} from 'react-redux'
import i18n from 'i18next'
import AzubiRow from '#components/o/MeineAzubis/AzubiRow'
import ActiveFilterBar from '#components/m/AzubiFilter/ActiveFilterBar'
import {AzubiTableHeader} from '#components/o/MeineAzubis/AzubiTableHeader'
import {transformToRowAzubi, sortAzubis, filterAzubis} from '#components/m/AzubiFilter/transform'
import {extractFilterOptionsMeineAzubis} from '#components/m/AzubiFilter/prepareOptionsDictionary'
import Text from '#components/a/Text'
import Pagination from '#components/m/Pagination'

function AzubiTable(props) {
  const {
    azubis,
    filterRules,
    reloadAzubis,
    sendMailToAusbilder,
    setShowNoAusbilderWithValidEmailModal,
    sortOptions,
    withFilter,
    toggleFilterRule,
    hasFilterForAbteilungen,
  } = props

  const sortAndFilterAzubis = _azubis => {
    const sortedAzubis = sortAzubis(sortOptions, _azubis)
    return filterAzubis(sortedAzubis, filterRules)
  }

  const globalFilter = azubi => matchingAzubiIds.includes(azubi.id)

  const {matchingAzubiIds} = useSelector(state => state.filter)
  const [globallyFilteredAzubis, setGloballyFilteredAzubis] = useState(azubis.filter(globalFilter))

  useEffect(() => {
    setGloballyFilteredAzubis(azubis.filter(globalFilter))
  }, [matchingAzubiIds.join(","), azubis])

  const transformedAzubis = transformToRowAzubi(globallyFilteredAzubis)
  const azubiList = withFilter ? sortAndFilterAzubis(transformedAzubis) : transformedAzubis
  const optionsDictionary = extractFilterOptionsMeineAzubis(azubis)
  const showNoAzubiInOwnAbteilungenText = azubiList.length === 0 && hasFilterForAbteilungen

  const filteredAzubis = azubiList.filter(azubi => azubi.isViewable || azubi.isViewable === undefined)

  const [visibleAzubis, setVisibleAzubis] = useState([])

  const scroll = (skip, take) => {
    setVisibleAzubis(filteredAzubis.slice(skip, skip + take))
  }

  if (showNoAzubiInOwnAbteilungenText) {
    return (
      <div className="text-noazubis">
        {withFilter && filterRules.length > 0 && (
          <ActiveFilterBar filterRules={filterRules} toggleFilterRule={toggleFilterRule} />
        )}
        <Text text={i18n.t('no_azubi_with_abteilung_fachausbilder')} />
      </div>
    )
  }

  if (filteredAzubis && filteredAzubis.length === 0) {
    return (
      <div className="text-noazubis">
        {withFilter && filterRules.length > 0 && (
          <ActiveFilterBar filterRules={filterRules} toggleFilterRule={toggleFilterRule} />
        )}
        <Text text={i18n.t('no_azubi_with_fachabteilung_filter_visible')} />
      </div>
    )
  }

  return (
    <div>
      {withFilter && filterRules.length > 0 && (
        <ActiveFilterBar filterRules={filterRules} toggleFilterRule={toggleFilterRule} />
      )}
      <Pagination data={filteredAzubis} scrollCallback={scroll} />
      <table>
        <AzubiTableHeader
          filterRules={filterRules}
          sendMailToAusbilder={sendMailToAusbilder}
          optionsDictionary={optionsDictionary}
          withFilter={withFilter}
        />
        <tbody>
          {visibleAzubis.map(azubi => (
            <AzubiRow
              key={azubi.id.toString()}
              azubi={azubi}
              updateParentState={() => setShowNoAusbilderWithValidEmailModal(true)}
              reloadAzubis={reloadAzubis}
            />
          ))}
        </tbody>
      </table>
    </div>
  )
}

AzubiTable.propTypes = {
  azubis: PropTypes.any,
  filterRules: PropTypes.any,
  reloadAzubis: PropTypes.any,
  sendMailToAusbilder: PropTypes.any,
  setShowNoAusbilderWithValidEmailModal: PropTypes.func,
  sortOptions: PropTypes.any,
  withFilter: PropTypes.bool,
  toggleFilterRule: PropTypes.func,
  hasFilterForAbteilungen: PropTypes.bool,
}

const mapActionsToProps = (state, ownProps) => {
  if (ownProps.withFilter) {
    return {
      reloadAzubis: actions.azubis.getAzubis,
      toggleFilterRule: actions.meineAzubis.toggleFilterRule,
    }
  }
  return {
    reloadAzubis: actions.azubis.getAzubis,
  }
}

const mapStateToProps = (state, ownProps) => {
  if (ownProps.withFilter) {
    return {
      sortOptions: state.meineAzubis.sortOptions,
      filterRules: state.meineAzubis.filterRules,
    }
  }
  return {}
}

export default connect(mapStateToProps, mapActionsToProps)(AzubiTable)
